import React, { useEffect, useState } from "react";
import ContentLayout from "../../layout/ContentLayout";
import { BiSave } from "react-icons/bi";
import ImageUploaderWithPost from "./ImageUploaderWithPost";
import axios from "axios";
import Swal from "sweetalert2";
import SelectImei from "../../forms/SelectImei";
import { get, post } from "../../services/apiService";

const CreateSlider = () => {
  const [formData, setFormData] = useState({
    image_path: [],
    product_id: [],
  });
  const [productListSelect, setProductListSelect] = useState([]);
  const [productListStored, setProductListSelectStored] = useState([]);
  const [searchProdFilter, setSearchProdFilter] = useState({ keyword: "" });
  const [currentSlider, setCurrentSlider] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;
  const [loading, setLoading] = useState(false);
  const handleFileChange = (files, name) => {
    console.log("Selected files:", files);
  };

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));


  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}get-sliders/${user.id}`)
      .then((res) => {
        setCurrentSlider(res.data.data);
        if (res.data.data.length > 0) {
          setFormData((prevData) => ({
            ...prevData,
            image_path: res.data.data[0].image_path,
            product_id: res.data.data[0].product_id,
          }));
          setProductListSelectStored(res.data.data[0].products)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getProductList = (page) => {
    if (searchProdFilter.keyword !== "") {
      const reqData = { keyword: searchProdFilter.keyword };
      const data = {
        keyword: searchProdFilter.keyword,
      };
      loadingCallback(true);
      post(`search-product-v1?page=${page}&limit=${perPage}`, data, token)
        .then((response) => {
          loadingCallback(false);
          if (response.status === 200) {
            const listData = response.data.data;
            setProductListSelect(listData);
            console.log("product names after search", listData);
          }
        })
        .catch((error) => {
          loadingCallback(false);
          console.log(error);
          localStorage.clear();
          localStorage.setItem("token", false);
          localStorage.setItem("isPinVerify", false);
          console.log("error", error);
          navigate("/login");
        });
    } else {
      loadingCallback(true);
      get(`product?page=${page}&limit=${perPage}`, token)
        .then((response) => {
          loadingCallback(false);
          if (response.data.data) {
            const listData = response.data.data;
            setProductListSelect(listData);
            console.log("product names before search", listData);
          }
        })
        .catch((error) => {
          loadingCallback(false);
          console.log("Full error object:", error);

          if (error.response) {
            console.log("Error response data:", error.response.data);
            console.log("Error response status:", error.response.status);
            console.log("Error response headers:", error.response.headers);

            if (error.response.status === 401) {
              localStorage.clear();
              localStorage.setItem("token", false);
              localStorage.setItem("isPinVerify", false);
              navigate("/login");
            } else {
              // Other error handling based on status or data
              console.error("Other API Error:", error.response.data);
            }
          } else {
            // Handle errors without a response (e.g., network issues)
            console.error("Network or other error:", error.message);
          }
        });
    }
  };

  useEffect(() => {
    getProductList(currentPage);
  }, [currentPage, searchProdFilter]);

  const loadingCallback = (loading) => {
    setLoading(loading);
  };
  useEffect(() => {
    console.log("Forme Data .............. ", formData);
    console.log("ProductList .............. ", productListSelect);
    console.log("ProductList .............. ", productListStored);
  });

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}save-sliders`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        title: "Added!",
        text: "Your slider has been added.",
        icon: "success",
      });
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <div>
      <ContentLayout>
        <div className="bg-white rounded-3xl mt-3 font-nunito p-[26px] ">
          <div className="mb-5">
            <span className="text-gray-400 text-xs">Slider</span>
            <p className="font-semibold text-sm">Create New Slider</p>
          </div>
          {/*slider form  */}
          <div className="grid grid-cols-2 gap-6 justify-center items-center">
            <div className="col-span-1 h-80">
              <ImageUploaderWithPost
                name={"image_path1"}
                isBig={true}
                onChange={handleFileChange}
                formData={formData}
                setFormData={setFormData}
                type={"slider"}
                index={0}
                image={
                  currentSlider && currentSlider.length > 0
                    ? currentSlider[0].image_path.length > 0
                      ? currentSlider[0].image_path[0]
                      : ""
                    : null
                }
                apiEndPoint={`${process.env.REACT_APP_API_URL}file-upload`}
              ></ImageUploaderWithPost>
              <div className="mt-2">
                <SelectImei
                  name="product_name"
                  options={/* productListStored.length > 0 ? productListStored : */ productListSelect}
                  value={formData?.product_id ? formData?.product_id[0] : ''}
                  flag='id'
                  label={"Product"}
                  placeholder="Select Product"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      product_id: {
                        ...formData.product_id,
                        0: e.value,
                      },
                    });
                  }}
                  onInputChangeData={(input) => {
                    setSearchProdFilter({
                      ...searchProdFilter,
                      keyword: input,
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-span-1">
              <div className="flex flex-col space-y-3 h-80">
                <ImageUploaderWithPost
                  name={"image_path2"}
                  onChange={handleFileChange}
                  formData={formData}
                  setFormData={setFormData}
                  type={"slider"}
                  index={1}
                  image={
                    currentSlider && currentSlider.length > 0
                      ? currentSlider[0].image_path.length > 1 &&
                        currentSlider[0].image_path[1]
                      : null
                  }
                  apiEndPoint={`${process.env.REACT_APP_API_URL}file-upload`}
                ></ImageUploaderWithPost>
                <div className="mt-2">
                  <SelectImei
                    name="product_name"
                    options={/* productListStored.length > 0 ? productListStored : */ productListSelect}
                    value={formData?.product_id ? formData?.product_id[1] : ''}
                    flag='id'
                    label={"Product"}
                    placeholder="Select Product"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        product_id: {
                          ...formData.product_id,
                          1: e.value,
                        },
                      });
                    }}
                    onInputChangeData={(input) => {
                      setSearchProdFilter({
                        ...searchProdFilter,
                        keyword: input,
                      });
                    }}
                  />
                </div>
                <ImageUploaderWithPost
                  name={"image_path3"}
                  onChange={handleFileChange}
                  apiEndPoint={`${process.env.REACT_APP_API_URL}file-upload`}
                  formData={formData}
                  setFormData={setFormData}
                  type={"slider"}
                  index={2}
                  image={
                    currentSlider && currentSlider.length > 0
                      ? currentSlider[0].image_path.length > 2 &&
                        currentSlider[0].image_path[2]
                      : null
                  }
                ></ImageUploaderWithPost>
                <div className="mt-2">
                  <SelectImei
                    name="product_name"
                    options={/* productListStored.length > 0 ? productListStored : */ productListSelect}
                    value={formData?.product_id ? formData?.product_id[2] : ''}
                    flag='id'
                    label={"Product"}
                    placeholder="Select Product"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        product_id: {
                          ...formData.product_id,
                          2: e.value,
                        },
                      });
                    }}
                    onInputChangeData={(input) => {
                      setSearchProdFilter({
                        ...searchProdFilter,
                        keyword: input,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={handleSubmit}
            type="submit"
            className="bg-[#407BFF] mx-auto mt-20 rounded-[5px] text-[#FFF] text-sm font-nunito font-bold py-2.5 px-[67px] flex items-center gap-2"
          >
            <BiSave className="text-xl"></BiSave> <span>Add Slider</span>
          </button>
        </div>
      </ContentLayout>
    </div>
  );
};

export default CreateSlider;
